import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import { HouseCorporateEveningIndividualFieldProps } from '../../form-container/HouseCorporateEveningIndividualFormContainer'
import { HouseCorporateEveningIndividualDto } from '../../../../../../../../../lib/graphql'
import { ControlledTextField } from '../../../../../../../../forms'

export const HouseCorporateEveningIndividualCapacityFields = ({
  control,
  isFieldDisabled,
}: Omit<HouseCorporateEveningIndividualFieldProps, 'currencyArea'>) => {
  const fieldProps = {
    disabled: isFieldDisabled,
    control,
    type: 'number',
    inline: true,
    rules: { required: 'Champ requis.' },
    placeholder: '0',
  }

  const { watch } = useFormContext<HouseCorporateEveningIndividualDto>()

  const minCapacity = watch('options.capacity.min')

  return (
    <>
      <ControlledTextField
        {...fieldProps}
        name='options.capacity.min'
        label={
          <FormattedMessage
            id='ui.HouseCorporateEveningIndividualFormFields.options.minCapacity'
            defaultMessage=' Nombre <bold>minimum</bold> de participants'
            values={{ bold: (content) => <b>{content}</b> }}
          />
        }
      />

      <ControlledTextField
        {...fieldProps}
        name='options.capacity.max'
        rules={{
          ...fieldProps.rules,
          validate: (value: string) => {
            // MaxCapacity should be greater than or equal to MinCapacity
            const hasError = Number(value) < minCapacity

            return !hasError
          },
        }}
        label={
          <FormattedMessage
            id='ui.HouseCorporateEveningIndividualFormFields.options.maxCapacity'
            defaultMessage=' Nombre <bold>maximum</bold> de participants'
            values={{ bold: (content) => <b>{content}</b> }}
          />
        }
      />
    </>
  )
}
